import { persistStore } from 'redux-persist';
import { createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import { set } from 'lodash';
import { composeWithDevTools } from '@redux-devtools/extension';

import rootReducer from './reducer';

const middleware = [thunk];

if (process.env.NODE_ENV === `development`) {
  const { createLogger } = require(`redux-logger`);

  middleware.push(createLogger());
}

const enhancer = composeWithDevTools(applyMiddleware(...middleware));

export const configureStore = () => {
  const store = (createStore as any)(rootReducer, enhancer);
  const persistor = persistStore(store);
  set(window, 'STORE', store);
  // AER-1668: expose the singleton persistor (mirrors window.STORE above) so
  // the login flow can force-flush the auth slice to disk immediately without
  // importing from app.component (which would create a module import cycle).
  set(window, 'PERSISTOR', persistor);
  return { store, persistor };
};
